import { AlertDialog, InfoIcon } from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../intl";

type Props = {
  onSave: () => unknown;
  onCancel: () => unknown;
  onDismiss: () => unknown;
};

export function SaveApplicationDialog(props: Props) {
  const formatMessage = useFormatMessage();

  return (
    <AlertDialog
      ariaLabelMessageForCloseIcon={formatMessage("Modal.closeButton")}
      type="confirmation"
      title={formatMessage("PreApprovedLoanSale.SaveApplicationModal.title")}
      message={formatMessage(
        "PreApprovedLoanSale.SaveApplicationModal.description"
      )}
      confirmLabel={formatMessage(
        "PreApprovedLoanSale.SaveApplicationModal.save"
      )}
      cancelLabel={formatMessage(
        "PreApprovedLoanSale.SaveApplicationModal.cancel"
      )}
      onConfirm={props.onSave}
      onCancel={props.onCancel}
      onDismiss={props.onDismiss}
      icon={InfoIcon}
    />
  );
}
